var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list",class:[`list--${_vm.view}`]},[_c('div',{staticClass:"product-list__row"},_vm._l((_vm.list),function(item){return _c('div',{key:`item-${item.id}`,staticClass:"product-list__col"},[_c('product-list-item',{attrs:{"item":item,"view":_vm.productView}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }